module.exports = __webpack_public_path__ + "img/_MG_3693.ea529c5b.jpg";